class Product implements ProductInterface {
  OCForm1: HTMLFormElement;
  invtProps: InvtProps;
  stockMessages: StockMessages;
  enablePayByPoints:boolean;
  priceViewCookieName: string;
  constructor({
    invtProps,
    stockMessages,
    enablePayByPoints,
    priceViewCookieName
  }) {
    this.OCForm1 = document.querySelector('#OCForm1');
    this.invtProps = invtProps;
    this.stockMessages = stockMessages;
    this.enablePayByPoints = enablePayByPoints;
    this.priceViewCookieName = priceViewCookieName
  }
  getPrice(tmpInvtID: string, type?: string): number {
    let returnValue = 0;
    try {
      if (type === 'listprice') {
        returnValue = Math.round(this.invtProps[tmpInvtID].listPrice * 100) / 100;
      } else if (type === 'listpoints') {
        returnValue = this.invtProps[tmpInvtID].listPoints;
      } else if (type === 'points') {
        returnValue = this.invtProps[tmpInvtID].points;
      } else {
        returnValue = Math.round(this.invtProps[tmpInvtID].price * 100) / 100;
      }
    } catch (e) { }
    return returnValue;
  }
  showHideATC(elementIndex: number, status: string): void {
    const cookieValue = getCookie(this.priceViewCookieName);
    if (status === 'out') {
      hideElement(`SPANQty${elementIndex}`);
      hideElement('quantity', elementIndex);
      hideElement('qty');
      hideElement('addToCartBtn');
      priceViewObj.displayATC=false;
      showElement(`SPANstock${elementIndex}`);
    } else {
      showElement(`SPANQty${elementIndex}`);
      showElement('quantity', elementIndex, '');
      showElement('qty', 0, '');
      if (!this.enablePayByPoints&&cookieValue==='points') {
        hideElement('addToCartBtn');
        priceViewObj.displayATC=false;
      } else {
        showElement('addToCartBtn');
        priceViewObj.displayATC=true;
      }
      hideElement(`SPANstock${elementIndex}`);
    }
  }
  doGetStockMessage(tmpItemID: string, elementIndex: number, InstockOverride: boolean): string {
    let returnValue = '';
    try {
      const invtID = productObj.getProductID(tmpItemID, elementIndex);
      const stkItem = this.invtProps[invtID].stkItem;
      const qtyAvail = this.invtProps[invtID].qtyAvail;
      const reOrdQty = this.invtProps[invtID].reOrdQty;
      const reOrdQtyOverride = this.invtProps[invtID].reOrdQtyOverride;
      const customInStockMessage = this.invtProps[invtID].customInStockMessage;
      if (stkItem === 0 || InstockOverride) {
        //dropship items always instock
        returnValue = (customInStockMessage === '') ? this.stockMessages.inStock : customInStockMessage;
        productObj.showHideATC(elementIndex, 'in');
      } else {
        if (qtyAvail <= 0) {
          returnValue = (customInStockMessage === '') ? this.stockMessages.outOfStock : customInStockMessage;
          productObj.showHideATC(elementIndex, 'out');
        } else if (qtyAvail <= reOrdQtyOverride || qtyAvail <= reOrdQty) {
          returnValue = this.stockMessages.lowStock;
          productObj.showHideATC(elementIndex, 'in');
        } else {
          returnValue = (customInStockMessage === '') ? this.stockMessages.inStock : customInStockMessage;
          productObj.showHideATC(elementIndex, 'in');
        }
      }
    } catch (e) { }
    return returnValue;
  }
  checkAddOnStock(tmpItemID: string, elementIndex: number, addOnProductID: string, addOnElementIndex: number, Instock: boolean): void {
    let addOnInvID = addOnProductID;
    let addOnExtGroups = null;
    let tmpExtValue: string;
    try {
      addOnExtGroups = this.OCForm1.elements['productIDExtensionGroups'][addOnElementIndex].value.split(';');
    } catch (e) { }
    let tmpExtGroups = this.OCForm1.elements['productIDExtensionGroups'][elementIndex].value.split(';');
    (<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[0]}`)).selectedIndex = (<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtGroups[0]}`)).selectedIndex;
    let addOnExtensionOptionsLength = (<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[0]}`)).options.length;
    for (let k = 0; k < addOnExtensionOptionsLength; k++) {
      if ((<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[0]}`)).options[k].value == (<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtGroups[0]}`)).options[(<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtGroups[0]}`)).selectedIndex].value) {
        (<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[0]}`)).selectedIndex = k;
      }
    }
    for (let i = 0; i < addOnExtGroups.length; i++) {
      if (addOnExtGroups[i] !== '') {
        if ((<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[i]}`)).selectedIndex === 0) {
          tmpExtValue = 'SELECT';
        } else {
          tmpExtValue = (<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[i]}`)).options[(<HTMLSelectElement>document.getElementById(`${addOnProductID}${addOnExtGroups[i]}`)).selectedIndex].value;
        }
        addOnInvID += tmpExtValue;
      }
    }
    if (tmpExtValue != 'SELECT') {
      const stockAddOnInvtID = addOnInvID;
      const stkItemAddOn = this.invtProps[stockAddOnInvtID].stkItem;
      const qtyAvailAddOn = this.invtProps[stockAddOnInvtID].qtyAvail;
      if ((stkItemAddOn === 0) || (Instock)) {
        document.getElementById('addition').style.visibility = 'visible';
      } else {
        if (qtyAvailAddOn <= 0) {
          if (this.OCForm1.productID[addOnElementIndex].checked) {
            this.OCForm1.productID[addOnElementIndex].checked = false;
          }
          document.getElementById('addition').style.visibility = 'hidden';
        } else {
          document.getElementById('addition').style.visibility = 'visible';
        }
      }
    }
  }
  getProductID(tmpItemID: string, elementIndex: number): string {
    let tmpExtensions = null;
    let returnValue = tmpItemID ? tmpItemID : (<HTMLInputElement>document.getElementById('productID')).value;
    let indexValue = elementIndex ? elementIndex : 0;
    let tmpExtValue = '';
    try {
      tmpExtensions = this.OCForm1.elements['productIDExtensionGroups'][indexValue].value.split(';');
    } catch (e) { }
    if (tmpExtensions === null) {
      tmpExtensions = this.OCForm1.elements['productIDExtensionGroups'].value.split(';');
    }
    for (let i = 0; i < tmpExtensions.length; i++) {
      if (tmpExtensions[i] !== '') {
        if (tmpItemID) {
          if ((<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtensions[i]}`)).selectedIndex === 0) {
            tmpExtValue = 'SELECT';
          } else {
            tmpExtValue = (<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtensions[i]}`)).options[(<HTMLSelectElement>document.getElementById(`${tmpItemID}${tmpExtensions[i]}`)).selectedIndex].value;
          }
        } else {
          if ((<HTMLSelectElement>document.getElementById(tmpExtensions[i])).selectedIndex === 0) {
            tmpExtValue = 'SELECT';
          } else {
            tmpExtValue = (<HTMLSelectElement>document.getElementById(tmpExtensions[i])).options[(<HTMLSelectElement>document.getElementById(tmpExtensions[i])).selectedIndex].value;
          }
        }
        returnValue += tmpExtValue;
      }
    }
    return returnValue;
  }
}
const productObj = new Product(classOptions);



interface ProductInterface {
  invtProps: InvtProps
  stockMessages: StockMessages;
  enablePayByPoints: boolean;
  priceViewCookieName: string;
}

interface InvtProps {
  price: string;
  listPrice: string;
  points: string;
  listPoints: string;
  stkItem: string;
  qtyAvail: string;
  reOrdQty: string;
  reOrdQtyOverride: string;
  customInStockMessage: string;
}
interface StockMessages {
  inStock: string;
  lowStock: string;
  outOfStock: string;
}